import { GridApiPro } from '@mui/x-data-grid-pro';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const HIGHLIGHT_CLASS = 'row-highlight';

const restartHighlightAnimation = (element: HTMLElement) => {
  if (!element.classList.contains(HIGHLIGHT_CLASS)) return;
  if (element.getAnimations({ subtree: true }).length > 0) return;
  element.classList.remove(HIGHLIGHT_CLASS);
  void element.offsetHeight;
  element.classList.add(HIGHLIGHT_CLASS);
};

export const useRowHighlight = (gridApi: React.RefObject<GridApiPro | null>) => {
  const [searchParameters] = useSearchParams();
  const highlightId = searchParameters.get('highlight') ?? undefined;
  const locationKey = useLocation().key;

  useEffect(() => {
    if (!highlightId) return;

    const scrollAttempt = globalThis.setTimeout(() => {
      const api = gridApi.current;
      if (!api) return;

      const rowIndex = api.getRowIndexRelativeToVisibleRows(highlightId);
      if (rowIndex !== undefined && rowIndex >= 0) {
        api.scrollToIndexes({ rowIndex });
      }

      const rowElement = api.getRowElement(highlightId);
      if (rowElement) restartHighlightAnimation(rowElement);
    }, 150);

    const fadeTimeout = globalThis.setTimeout(() => {
      const url = new URL(globalThis.location.href);
      if (url.searchParams.has('highlight')) {
        url.searchParams.delete('highlight');
        globalThis.history.replaceState(globalThis.history.state, '', url.toString());
      }
    }, 2000);

    return () => {
      globalThis.clearTimeout(scrollAttempt);
      globalThis.clearTimeout(fadeTimeout);
    };
  }, [highlightId, gridApi, locationKey]);

  return highlightId;
};
